<template>
  <dashboard-layout :dark="dark" :active="3">
    <!--====================== Header End ======================-->
    <!--====================== Page Title Start ======================-->
    <div class="pt-4 pb-5">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <p class="h5 text-primary fw-bold">
              Welcome Back, <span class="text-gray"> Admin</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <!--====================== Page Title End ======================-->

    <!--====================== Content Body Start ======================-->
     <section class="pb-5">
        <div class="container-fluid">
          <div class="row mb-5">
            <div class="col-xl-4 col-lg-4 col-md-6">
              <div class="card border-0">
                <div class="card-body px-0">
                  <div class="d-flex align-items-start border-bottom border-gray-light pb-3 mb-3">
                    <img class="rounded-circle me-3" src="../../assets/images/profile/2.png" width="60" height="60"
                      loading="lazy" alt="…">
                    <div>
                      <span class="text-gray">Hello</span>
                      <h2 class="h5 fw-semi-bold mb-2">Admin</h2>
                      <a href="tel:+12355547" class="mb-1 fs-6 text-gray"><i class="fas fa-phone-alt me-2 text-primary fa-xs"></i> +1 235 5547</a><br>
                      <a href="mailto:hello@example.com" class="mb-1 fs-6 text-gray"><i class="fa fa-envelope me-2 text-primary"></i>hello@example.com</a>
                    </div>
                  </div>

                  <ul>
                    <li class="mb-1">
                      <h3 class="h6 fw-semi-bold me-4 d-inline-block">Address</h3>
                      <span class="text-muted">House 14, Road 9, Gulshan, Dhaka</span>
                    </li>
                    <li class="mb-1">
                      <h3 class="h6 fw-semi-bold me-4 d-inline-block">Total Log</h3>
                      <span class="text-gray">103 Time (Today 5 Times)</span>
                    </li>
                    <li class="mb-1">
                      <h3 class="h6 fw-semi-bold text-danger me-4 d-inline-block">Last Log</h3>
                      <span class="text-danger">3 February, 2019, 10:00 PM</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
              <div class="card border-0">
                <div class="card-header border-bottom mb-3 p-0 pb-3">
                  <h3 class="fw-semi-bold card-title">Wallet</h3>
                </div>
                <div class="card-body">
                  <div class="mb-4">
                    <p class="text-gray mb-1">Available BTC</p>
                    <h3 class="fw-semi-bold">0.0230145 BTC</h3>
                  </div>

                  <div class="d-flex justify-content-between mb-4">
                    <div>
                      <p class="text-gray mb-1">Buy this month</p>
                      <h5 class="fw-semi-bold">3.0215485 BTC</h5>
                    </div>
                    <div>
                      <p class="text-gray mb-1">Sell this month</p>
                      <h5 class="fw-semi-bold">3.0215485 BTC</h5>
                    </div>
                  </div>
                  <div class="btn-group mb-3 mt-2 w-100 flex-wrap">
                    <button class="btn btn-primary m-2">Sell</button>
                    <button class="btn btn-success m-2">Buy</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-4">
              <div class="card border-0">
                <div class="card-header border-bottom mb-3 p-0 pb-3">
                  <h3 class="fw-semi-bold card-title">Withdraw</h3>
                </div>
                <div class="card-body">
                  <form action="#" @submit.prevent="">
                    <div class="form-group">
                      <div class="input-group mb-3">
                        <div class="input-group-prepend d-flex">
                          <label class="input-group-text border-0 bg-light-200"><i class="far fa-money-bill-alt text-dark-400"></i></label>
                        </div>
                        <input type="text" class="form-control" placeholder="5000 USD">
                      </div>
                    </div>
                    <div class="form-group">
                      <div class="input-group mb-3">
                        <div class="input-group-prepend d-flex">
                          <label class="input-group-text border-0 bg-light-200"><i class="fas fa-university text-dark-400"></i></label>
                        </div>
                        <select class="form-select border-end-0">
                          <option>Bank of America ********45845</option>
                          <option>Master Card ***********5458</option>
                        </select>
                      </div>
                    </div>
                    <button class="btn btn-primary btn-block w-100">Withdraw Now</button>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="table-card border-0 rounded-default box-shadow transaction-table">
                <div class="card-header bg-transparent border-0 p-0">
                  <h2 class="h3 fw-semi-bold card-title mb-5">All Activities </h2>
                </div>
                <div class="card-body p-0">
                  <table>
                    <tbody>
                      <tr
                        v-for="(transaction, index) in paginatedTransactions"
                        :key="`${transaction.wallet}-${transaction.date}-${index}`"
                        :class="bg"
                      >
                        <th data-label="Arrow Icon"><i
                            class="fa-md rounded-circle text-white"
                            :class="transaction.type === 'Deposit' ? 'la la-arrow-up bg-success' : 'la la-arrow-down bg-danger'"></i></th>
                        <th data-label="Badge"><span
                            class="badge inline-flex align-items-center text-white"
                            :class="transaction.type === 'Deposit' ? 'bg-success' : 'bg-danger'">{{ transaction.type }}</span></th>
                        <th data-label="Icon">
                          <div class="d-flex align-items-center">
                            <span class="text-capitalize fw-semi-bold">{{ transaction.clientName }}</span>
                          </div>
                        </th>
                        <th data-label="Card"><span class="fw-semi-bold">{{ transaction.methodToken || transaction.wallet }}</span></th>
                        <th data-label="Amout BTC"><span
                            class="fw-semi-bold"
                            :class="transaction.type === 'Deposit' ? 'text-success' : 'text-danger'">{{ transaction.type === "Deposit" ? "+" : "-" }}{{ formatAmount(transaction.settledAmount) }}</span></th>
                        <th data-label="Amout USD"><span class="fw-semi-bold">{{ formatDate(transaction.date) }}</span></th>
                      </tr>
                    </tbody>
                  </table>
                  <div class="d-flex justify-content-between align-items-center flex-column flex-md-row gap-3 mt-4">
                    <p class="text-gray mb-0">
                      Showing {{ pageStart }}-{{ pageEnd }} of {{ sortedTransactions.length }}
                      transactions
                    </p>
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="sortedTransactions.length"
                      :per-page="perPage"
                      pills
                      first-number
                      last-number
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


  </dashboard-layout>
</template>

<script>
import DashboardLayout from "../../components/Dashboard/DashboardLayout.vue";
import transactions from "../../data/transactions";
// import BtcChart from "../../components/Tradix/Charts/BtcChart.vue";
// import TimelineChart from "../../components/Tradix/Charts/TimelineChart.vue";
// import CurrencyForm from "../../components/Tradix/CurrencyForm2.vue";
export default {
  components: { DashboardLayout, },
  props: {
    dark: Boolean,
  },
  data() {
    return {
      active: "all",
      bg:this.dark ? 'text-white bg-dark-2':'text-gray bg-light-200',
      currentPage: 1,
      perPage: 10,
      transactions,
    };
  },
  computed: {
    sortedTransactions() {
      return [...this.transactions]
        .sort((left, right) => this.parseDate(right.date) - this.parseDate(left.date))
    },
    paginatedTransactions() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.sortedTransactions.slice(start, start + this.perPage);
    },
    pageStart() {
      if (!this.sortedTransactions.length) {
        return 0;
      }
      return (this.currentPage - 1) * this.perPage + 1;
    },
    pageEnd() {
      return Math.min(this.currentPage * this.perPage, this.sortedTransactions.length);
    },
  },
  methods: {
    formatAmount(value) {
      return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    },
    formatDate(value) {
      const parsedDate = this.parseDate(value);
      if (!parsedDate) {
        return value;
      }
      return new Intl.DateTimeFormat("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      }).format(parsedDate);
    },
    parseDate(value) {
      if (!value) {
        return null;
      }
      if (typeof value === "string") {
        const slashDateMatch = value.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
        if (slashDateMatch) {
          const [, day, month, year] = slashDateMatch;
          return new Date(Number(year), Number(month) - 1, Number(day));
        }
      }
      return new Date(value);
    },
  },
};
</script>
